import { ShouldRenderTabsService } from '@philips-emr/hpms-provider-accreditation-commons';
import { TabControlAPI, TabWithContentAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import BaseController from '../BaseController';

@Controller({ fragment: 'provider-accreditation-professionals' })
export default class ProviderAccreditatonProfessionalsController extends BaseController {

  @OnMount('tab-control')
  onMountTab(event: MountEvent): void {
    const api = event.target as TabControlAPI;
    ShouldRenderTabsService.chooseDefaultTab(api, ['employees', 'amountProfessionals']);
  }

  @OnMount('tab-employees')
  onMountEmployees(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, 'employees');
  }

  @OnMount('tab-amount-professionals')
  onMountProfessionalsTab(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, 'amountProfessionals');
  }

}
